const OUTLOOK_RESET_PATTERN = /#outlook\s*a\s*\{[^}]*padding\s*:\s*0\s*;?[^}]*\}/i;
const IMAGE_RESET_PATTERN = /img\s*\{[^}]*-ms-interpolation-mode\s*:\s*bicubic[^}]*\}/i;

function isMjmlDefaultResetStyle(styleTag: string) {
	const css = styleTag.replace(/<style\b[^>]*>/i, '').replace(/<\/style>/i, '');

	return OUTLOOK_RESET_PATTERN.test(css) && IMAGE_RESET_PATTERN.test(css);
}

export function stripMjmlDefaultHeadReset(html: string) {
	return html.replace(
		/<style\b([^>]*)>([\s\S]*?)<\/style>/gi,
		(styleTag, attributes, css) => {
			if (!isMjmlDefaultResetStyle(styleTag)) return styleTag;

			const cleanedCss = css
				.replace(OUTLOOK_RESET_PATTERN, '')
				.replace(IMAGE_RESET_PATTERN, '')
				.trim();

			if (!cleanedCss) return '';

			return `<style${attributes}>${cleanedCss}</style>`;
		},
	);
}
